import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M10 3.3333c3.675 0 6.6666 2.9917 6.6666 6.6667S13.675 16.6667 10 16.6667 3.3333 13.675 3.3333 10 6.325 3.3333 10 3.3333m0-1.6666C5.4 1.6667 1.6666 5.4 1.6666 10S5.4 18.3333 10 18.3333 18.3333 14.6 18.3333 10 14.6 1.6667 10 1.6667M10.8333 10V6.6667H9.1666V10h-2.5L10 13.3333 13.3333 10z" /></g>,<defs key="1"></defs>,]
, 'DisplayArrowCircleDownx');
